import React from 'react';
import { Box, BoxProps } from '@chakra-ui/react';
import { DistanceBetween } from './types';

type DefaultScreenTileComponentBoxProps = BoxProps & {
  distanceBetweenTileComponents?: DistanceBetween;
};

export const DefaultScreenTileComponentBox: React.FC<DefaultScreenTileComponentBoxProps> = ({
  distanceBetweenTileComponents: distance = DistanceBetween.wide,
  children,
  ...props
}) => {
  return (
    <Box pl={10} my={distance} {...props}>
      {children}
    </Box>
  );
};
